import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../../core/services/language.service';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { BridgeMode } from '@hg-com/xwc-js-bridge/dist/native-app.service';
import { availableLanguages } from '../../../../core/core.const';
import { DataService } from 'src/core/services/data.service';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss'],
})
export class LangSwitcherComponent implements OnInit {
  language = this.languageService.i18NextService.language;
  languages: string[] = this.languageService.getAvailableLanguages();
  open = false;

  constructor(
    private languageService: LanguageService,
    private dataService: DataService,
    private nis: NativeIntegrationService
  ) {}

  ngOnInit(): void {
    this.languageService.i18NextService.events.initialized.subscribe((e) => {
      if (e) {
        this.updateState(this.languageService.i18NextService.language);
      }
    });
    if (this.nis.native.mode > BridgeMode.Mock) {
      this.nis.basics.getDeviceLanguage$().then((lang) => {
        console.log('[LANG SWITCHER]: Device language: ' + lang.data);
        console.log(this.languageService.i18NextService.language);
        console.log(lang.data);
        if (
          this.languageService.i18NextService.language !== lang.data &&
          lang.data !== null &&
          availableLanguages.includes(lang.data) &&
          localStorage.getItem('deviceLangSet') === null
        ) {
          console.log('[LANG SWITCHER]: Change Language to ' + lang.data);
          this.changeLanguage(lang.data);
        }
      });
    }
  }

  toggleLangSwitcher(): void {
    this.open = !this.open;
  }

  // lang switcher i18next
  changeLanguage(lang: string): void {
    if (lang !== this.languageService.i18NextService.language) {
      this.dataService.getLegal(lang);
      this.dataService.getTranslations(lang);
      this.languageService.i18NextService.changeLanguage(lang).then((x) => {
        this.updateState(lang);
        const self = this;
        localStorage.setItem('deviceLangSet', lang);
        setTimeout(() => {
          self.toggleLangSwitcher();
          document.location.reload();
        }, 400);
      });

    }
  }

  private updateState(lang: string): void {
    this.language = lang;
  }
}
